import React, { memo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import "../../styles/ModalShared.css";

const EditConfirmationModalComponent = ({
  isOpen,
  toggle,
  onSave,
  editTitle,
  initialValue,
}) => {
  const [value, setValue] = useState(initialValue || "");

  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="custom-modal">
      <ModalBody className="text-center">
        <h5 className="modal-title mb-2">{editTitle}</h5>
        <textarea
          className="form-control mb-3"
          rows={3}
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Edit your message"
        />
      </ModalBody>
      <div className="custom-footer">
        <button className="modal-btn cancel-btn" onClick={toggle}>
          Cancel
        </button>
        <div className="divider" />
        <button
          className="modal-btn update-btn"         
          onClick={() => onSave(value)}
          disabled={value.trim() === ""}
        >
          Save
        </button>
      </div>
    </Modal>
  );
};

EditConfirmationModalComponent.displayName = "EditConfirmationModal";

const EditConfirmationModal = memo(EditConfirmationModalComponent);

EditConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  editTitle: PropTypes.string,
  initialValue: PropTypes.string,
};

export default EditConfirmationModal;
